export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  image: string;
  tags: string[];
  featured?: boolean;
}

export const articles: Article[] = [
  {
    slug: 'getting-started-guide',
    title: '一起草平台新手指南：三步快速上手',
    excerpt: '刚接触一起草？这篇指南将帮助你在三分钟内完成注册、了解核心功能，并开始你的第一篇文章创作。',
    content: `<h2>欢迎来到一起草</h2><p>一起草是一个基于人工智能技术的内容创作平台，无论你是自媒体创作者、企业营销人员还是学生，都能在这里获得高效的内容创作体验。</p><h3>第一步：注册账号</h3><p>访问一起草官网，点击右上角的「注册」按钮。填写基本信息后，系统会发送验证邮件到你的邮箱。完成验证后即可登录平台。</p><h3>第二步：了解核心功能</h3><p>一起草目前提供以下核心功能：</p><ul><li><strong>AI智能写作</strong>：输入关键词或主题，AI自动生成高质量文章</li><li><strong>文章润色</strong>：对已有内容进行语法优化和风格调整</li><li><strong>大纲生成</strong>：快速生成结构化文章大纲</li><li><strong>多语言翻译</strong>：支持中英日韩等多语言互译</li><li><strong>SEO优化建议</strong>：自动分析并给出搜索引擎优化建议</li></ul><h3>第三步：开始创作</h3><p>进入创作中心，选择你需要的功能模块，输入主题或关键词，点击生成即可。你还可以对生成的内容进行二次编辑和调整，直到满意为止。</p>`,
    category: 'feature-guide',
    author: '一起草官方',
    date: '2026-08-10',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20creative%20workspace%20with%20laptop%20and%20notebook%20on%20wooden%20desk%2C%20warm%20ambient%20lighting%2C%20clean%20aesthetic%2C%20soft%20shadows%2C%20editorial%20photography%2C%20high%20detail%2C%20neutral%20beige%20background%2C%20cozy%20atmosphere&width=800&height=450&seq=article-guide-01&orientation=landscape',
    tags: ['新手指南', '快速上手', '平台介绍'],
    featured: true,
  },
  {
    slug: 'ai-writing-tips',
    title: 'AI写作技巧：如何让生成内容更有温度',
    excerpt: '掌握这些AI写作技巧，让你的AI生成内容不再冷冰冰，而是充满人情味和个性化表达。',
    content: `<h2>为什么AI内容需要"温度"？</h2><p>随着AI写作工具的普及，越来越多的内容由AI生成。然而，纯粹的机器产出往往缺乏情感共鸣。如何在高效创作的同时保持内容的温度，成为每位创作者需要思考的问题。</p><h3>技巧一：注入个人故事</h3><p>在AI生成框架的基础上，加入你自己的经历和感悟。比如在写产品测评时，可以分享你实际使用的体验和感受。</p><h3>技巧二：使用口语化表达</h3><p>避免过于书面化的语言，适当使用"你知道吗"、"说实话"等口语化表达，拉近与读者的距离。</p><h3>技巧三：设定明确的人设</h3><p>在提示词中明确你的身份和语气风格，比如"以一位有十年经验的营销专家身份，用亲切幽默的语气撰写"。这样AI生成的内容会更加统一和有辨识度。</p><h3>技巧四：善用一起草的润色功能</h3><p>生成初稿后，使用一起草的润色功能进行二次优化。你可以选择"温暖友好"或"专业严谨"等不同风格进行定向调整。</p>`,
    category: 'tutorial',
    author: '李明月',
    date: '2026-08-08',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20coffee%20shop%20interior%20with%20warm%20lighting%2C%20person%20typing%20on%20laptop%2C%20steaming%20coffee%20cup%2C%20soft%20natural%20light%20from%20window%2C%20minimalist%20decor%2C%20comfortable%20atmosphere%2C%20editorial%20style%2C%20high%20detail&width=800&height=450&seq=article-tips-02&orientation=landscape',
    tags: ['写作技巧', 'AI创作', '内容优化'],
  },
  {
    slug: 'platform-update-2026-08',
    title: '一起草2026年8月更新公告：全新界面与功能升级',
    excerpt: '一起草迎来重大更新，全新设计的用户界面更加直观易用，同时上线多项新功能，提升你的创作效率。',
    content: `<h2>更新概览</h2><p>感谢所有用户的支持与反馈！经过数月的研发和优化，一起草为你带来全新版本。本次更新涵盖界面设计、功能体验和性能优化三大方面。</p><h3>全新用户界面</h3><p>我们重新设计了整个平台的界面，采用了更加简洁现代的设计语言。新的导航系统让你能够更快找到所需功能，创作中心的操作流程也得到了大幅简化。</p><h3>新功能上线</h3><ul><li><strong>批量生成模式</strong>：一次性生成多篇相关主题的文章，大幅提升内容产出效率</li><li><strong>智能改写工具</strong>：输入原文，AI自动生成多个不同风格和角度的改写版本</li><li><strong>协作编辑功能</strong>：支持团队成员共同编辑和审阅文档，实时同步修改</li></ul><h3>性能优化</h3><p>生成速度提升40%，页面加载时间缩短50%。我们还优化了移动端的适配体验，让你随时随地都能轻松创作。</p>`,
    category: 'news',
    author: '一起草技术团队',
    date: '2026-08-05',
    readTime: '4分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20tech%20office%20with%20sleek%20minimalist%20design%2C%20large%20display%20screens%20showing%20data%20dashboards%2C%20clean%20white%20desks%2C%20warm%20accent%20lighting%2C%20professional%20atmosphere%2C%20editorial%20photography%2C%20high%20detail&width=800&height=450&seq=article-update-03&orientation=landscape',
    tags: ['更新公告', '新功能', '版本升级'],
  },
  {
    slug: 'account-security-guide',
    title: '账号安全指南：保护你的一起草账号',
    excerpt: '账号安全是使用在线平台的基础，本文详细讲解如何设置强密码、开启双重验证，全方位保护你的账号。',
    content: `<h2>为什么账号安全很重要？</h2><p>你的一起草账号包含了你的创作记录、个人偏好和历史数据。保护好账号安全，就是保护好你的创作成果。</p><h3>设置强密码</h3><p>建议使用至少12位的密码，包含大小写字母、数字和特殊字符。避免使用生日、姓名等容易猜测的信息。</p><h3>开启双重验证</h3><p>在「账号设置」-「安全设置」中开启双重验证。每次登录时需要输入手机验证码，即使密码泄露也能有效防止他人登录。</p><h3>定期检查登录记录</h3><p>定期查看账号的登录历史，如发现异常登录记录，立即修改密码并联系客服处理。</p><h3>警惕钓鱼网站</h3><p>请认准一起草唯一官方网站地址，不要通过非官方渠道输入账号密码。官方不会通过邮件或短信索要你的密码。</p>`,
    category: 'faq',
    author: '一起草安全团队',
    date: '2026-08-03',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Digital%20security%20concept%20with%20lock%20icon%20on%20screen%2C%20minimalist%20workspace%20setup%2C%20soft%20warm%20lighting%2C%20clean%20aesthetic%2C%20professional%20atmosphere%2C%20high%20detail%2C%20neutral%20tones&width=800&height=450&seq=article-security-04&orientation=landscape',
    tags: ['账号安全', '安全指南', '常见问题'],
  },
  {
    slug: 'content-marketing-strategy',
    title: '内容营销策略：用一起草打造你的品牌内容矩阵',
    excerpt: '如何利用一起草平台高效构建品牌内容体系？本文分享完整的内容营销策略框架与实战案例。',
    content: `<h2>内容营销的新时代</h2><p>AI工具的出现彻底改变了内容营销的玩法。以前需要一周才能完成的内容策划和撰写，现在可能只需要一天。但这不意味着内容质量可以降低——恰恰相反，AI工具让我们有更多时间专注于策略和创意。</p><h3>确定内容定位</h3><p>在使用一起草之前，首先要明确你的品牌定位和目标受众。你是谁？你要对谁说话？你想传达什么价值？这些问题想清楚后，AI工具才能真正为你所用。</p><h3>规划内容矩阵</h3><p>一个完整的内容矩阵应包括：品牌故事、产品介绍、行业洞察、用户案例、操作指南等不同维度的内容。使用一起草的大纲生成功能，可以快速为每个维度规划内容框架。</p><h3>保持更新频率</h3><p>内容营销的核心在于持续输出。建议每周至少更新2-3篇高质量内容。一起草的批量生成功能可以帮助你在短时间内完成一周的内容储备。</p>`,
    category: 'tutorial',
    author: '王思涵',
    date: '2026-08-01',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Creative%20marketing%20team%20brainstorming%20around%20whiteboard%20in%20modern%20office%2C%20warm%20natural%20light%2C%20sticky%20notes%2C%20collaborative%20atmosphere%2C%20minimalist%20design%2C%20editorial%20photography%2C%20high%20detail&width=800&height=450&seq=article-marketing-05&orientation=landscape',
    tags: ['内容营销', '品牌策略', '创作技巧'],
  },
  {
    slug: 'version-history-feature',
    title: '版本历史功能详解：再也不怕误删内容',
    excerpt: '一起草新增版本历史功能，自动保存每次编辑记录，支持随时回溯到任意历史版本，创作更安心。',
    content: `<h2>告别"误删"的焦虑</h2><p>相信很多创作者都有过这样的经历：辛苦写了半天的内容，不小心删掉了一段，又无法撤销。一起草的版本历史功能彻底解决了这个痛点。</p><h3>自动保存机制</h3><p>系统每隔30秒自动保存一次当前版本，你无需手动操作。每次保存都会生成一个版本快照，完整记录当时的文档状态。</p><h3>版本对比</h3><p>你可以选择任意两个版本进行对比，系统会用高亮标注出修改的部分。新增内容显示为绿色，删除内容显示为红色。</p><h3>一键恢复</h3><p>找到你需要的版本后，点击「恢复此版本」即可一键还原。恢复操作也会创建一个新的版本快照，所以即使恢复错了也可以再次找回。</p>`,
    category: 'feature-guide',
    author: '一起草产品团队',
    date: '2026-07-28',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20digital%20interface%20showing%20document%20version%20history%20timeline%2C%20soft%20warm%20lighting%2C%20modern%20UI%20design%2C%20high%20detail%2C%20professional%20aesthetic&width=800&height=450&seq=article-version-06&orientation=landscape',
    tags: ['版本历史', '功能介绍', '数据安全'],
  },
  {
    slug: 'mobile-app-announcement',
    title: '一起草移动端App即将上线：随时随地创作',
    excerpt: '一起草移动端App进入内测阶段，支持iOS和Android双平台，让你在通勤、旅行中也能高效创作。',
    content: `<h2>移动创作时代来临</h2><p>我们深知，灵感往往在不经意间闪现。为了让你能够随时随地记录和创作，一起草移动端App即将正式发布。</p><h3>核心功能</h3><p>移动端App将完整保留Web端的核心功能，包括AI写作、文章润色、大纲生成等。同时针对移动端操作习惯进行了专门的交互优化。</p><h3>离线模式</h3><p>即使在无网络环境下，你也可以使用离线模式进行文字编辑。当网络恢复后，内容会自动同步到云端。</p><h3>语音输入</h3><p>支持语音转文字功能，通过说话就能快速生成文字内容，然后使用AI进行整理和优化。</p><h3>内测招募</h3><p>目前我们正在招募内测用户，如果你希望提前体验移动端App，请在官网提交内测申请。</p>`,
    category: 'news',
    author: '一起草官方',
    date: '2026-07-25',
    readTime: '4分钟',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20modern%20writing%20app%20interface%20on%20minimalist%20desk%2C%20warm%20natural%20light%2C%20clean%20aesthetic%2C%20editorial%20photography%2C%20high%20detail%2C%20neutral%20background&width=800&height=450&seq=article-mobile-07&orientation=landscape',
    tags: ['移动端', 'App发布', '产品动态'],
  },
  {
    slug: 'common-login-issues',
    title: '登录常见问题汇总：无法登录怎么办？',
    excerpt: '汇总用户反馈最多的登录相关问题，包括密码忘记、验证码收不到、账号被锁定等情况的自助解决方法。',
    content: `<h2>登录问题自助排查</h2><p>如果你在登录一起草时遇到问题，不要着急。以下是最常见的登录问题及其解决方法。</p><h3>忘记密码</h3><p>点击登录页面的「忘记密码」，输入注册邮箱，系统会发送密码重置链接。如果没有收到邮件，请检查垃圾邮件箱。</p><h3>验证码收不到</h3><p>首先确认手机号码是否正确。如果号码无误，请等待60秒后重新发送。每天最多发送5次验证码。如仍无法收到，建议切换为邮箱验证方式。</p><h3>账号被锁定</h3><p>连续5次输入错误密码后，账号将被临时锁定30分钟。等待30分钟后重试，或通过「忘记密码」重置密码后立即解锁。</p><h3>清除浏览器缓存</h3><p>有时浏览器缓存会导致登录异常。尝试清除浏览器缓存和Cookie后重新登录。</p>`,
    category: 'faq',
    author: '一起草客服团队',
    date: '2026-07-22',
    readTime: '4分钟',
    image: 'https://readdy.ai/api/search-image?query=Laptop%20screen%20showing%20login%20page%20on%20minimalist%20desk%2C%20warm%20cozy%20lighting%2C%20clean%20workspace%2C%20soft%20shadows%2C%20editorial%20photography%2C%20high%20detail%2C%20neutral%20beige%20tones&width=800&height=450&seq=article-login-08&orientation=landscape',
    tags: ['登录问题', '账号问题', '常见问题'],
  },
  {
    slug: 'team-collaboration-guide',
    title: '团队协作功能完整使用指南',
    excerpt: '一起草团队版支持多人实时协作编辑，本文详细介绍团队创建、成员管理、权限设置等完整操作流程。',
    content: `<h2>高效团队创作的秘诀</h2><p>一起草团队协作功能让多人同时编辑同一文档成为可能，告别邮件来回发送文档的繁琐流程。</p><h3>创建团队空间</h3><p>在「团队管理」中点击「创建团队」，输入团队名称和描述。创建后你将自动成为团队管理员。</p><h3>邀请成员</h3><p>通过邮箱或分享链接邀请团队成员加入。你可以为不同成员设置不同权限：管理员、编辑者、只读查看者。</p><h3>实时协作编辑</h3><p>多人同时打开同一文档时，可以看到彼此的编辑光标位置和实时修改内容。所有修改自动保存，不会产生冲突。</p><h3>评论与审阅</h3><p>支持在文档中任意位置添加评论，标记需要修改的地方。审阅模式下可以逐条处理评论，确保每个反馈都得到响应。</p>`,
    category: 'feature-guide',
    author: '一起草产品团队',
    date: '2026-07-20',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Diverse%20creative%20team%20collaborating%20around%20large%20monitor%20in%20modern%20office%2C%20warm%20lighting%2C%20minimalist%20design%2C%20natural%20interaction%2C%20editorial%20photography%2C%20high%20detail&width=800&height=450&seq=article-team-09&orientation=landscape',
    tags: ['团队协作', '功能指南', '效率提升'],
  },
];